export const normalizeDisplayLabel = (value: unknown): string => {
  if (value === null || value === undefined) {
    return "";
  }

  const cleaned = String(value)
    .replace(/[_\s]+/g, " ")
    .replace(/\s+\[/g, " [")
    .trim();

  if (/^[a-z]+$/.test(cleaned)) {
    return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
  }

  return cleaned;
};

export const normalizeDisplayLabelWithoutUndefined = (
  value: unknown,
): string => {
  return normalizeDisplayLabel(value)
    .replace(/\bundefined\b/gi, "")
    .replace(/ {2,}/g, " ")
    .trim();
};
